<template>
    <div class="mt-3">

        <v-card>

            <v-row>

                <v-col class="d-flex justify-center" v-for="item in integrations" :key="item.name">

                    <integrations-card :integration="item" />

                </v-col>

                <v-col cols='12' class="d-flex justify-center">

                    <skeleton-integration-card @openDialog='handleDialogEvent($event)' />

                </v-col>

            </v-row>

            <v-dialog width="500" v-if="dialogOptions" v-model="dialogOptions" :fullscreen='isMobile ? true : false' transition="dialog-bottom-transition">

                <v-toolbar dark color="primary">

                    <v-btn icon dark @click="dialogOptions = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>

                    <v-toolbar-title> {{$t('integration')}}</v-toolbar-title>

                    <v-spacer></v-spacer>

                </v-toolbar>

                <v-card class='d-flex overflow-hidden'>

                    <new-integration-card v-if="dialogNewIntegration" @newIntegration='handleNewIntegration' />

                </v-card>

            </v-dialog>

        </v-card>

    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { GET_INTEGRATIONS } from '../../store/mutations'
import NewIntegrationCard from '../components/dashIntegration/NewIntegrationCard.vue'
import SkeletonIntegrationCard from '../components/dashIntegration/SkeletonIntegrationCard.vue'
import IntegrationsCard from '../components/dashIntegration/IntegrationsCard.vue'

export default {

    components: { SkeletonIntegrationCard, NewIntegrationCard, IntegrationsCard },

    name: 'DashIntegration',

    data() {
        return {

            dialogOptions: false,
            dialogNewIntegration: false,
            dialogOzmapOptions: false

        }
    },

    computed: {

        ...mapGetters({ integrations: `ProviderVuex/integrations` })

    },

    methods: {

        ...mapActions({ getIntegrations: `ProviderVuex/${GET_INTEGRATIONS}` }),

        handleDialogEvent(event) {

            if (event === 'dialogNewIntegration') {

                this.dialogNewIntegration = true

            } else if (event === 'dialogOzmapOptions') {

                this.dialogOzmapOptions = true
                this.dialogNewIntegration = false

            }

            this.dialogOptions = true


        },

        async handleNewIntegration() {

            try {

                this.loading = true

                this.newIntegrationConfig = false

                await this.getIntegrations()

                this.dialogOptions = false

            } catch (error) {

                console.log(error)

                return this.showToast(error.message, this.$t('integrations.new_integration_title'), 'error')


            } finally {

                this.loading = false

            }
        }

    },

    async created() {

        try {

            this.loading = true

            await this.getIntegrations()

        } catch (error) {

            console.log(error)

            return this.showToast(error.message, this.$t('integrations.new_integration_title'), 'error')


        } finally {

            this.loading = false

        }
    },

}
</script>

<style>

</style>